var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',[_c('i',{staticClass:"f-icon icon-kong"}),_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }